export const WT_FLAGS_KEYS = {
  SIDEBAR_SECTION_RESIZABLE: 'sidebar.section.resizable',
};
